import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
    getAccountDocuments,
    emptyAccountDocuments,
    createAccountDocument,
} from '../../../../../../actions/accountDetailsActions/documents.actions';
import {createLoadingSelector, getAccountDetails, getUserPermission} from '../../../../../../selectors';
import Document from "./Document";
import Loader from "../../../../../../components/Loader";
import isEmpty from "../../../../../../utils/helpers";
import {showModal} from "src/actions/modal.actions";



class Documents extends Component {

    componentDidMount() {
        this.props.getAccountDocuments(this.props.accountId);
    }

    componentWillUnmount() {
        this.props.emptyAccountDocuments();
    }


    render() {

        const {
            accountId,
            documentsLoader,
            documents,
            showModal,
            canAdd,
            canEdit,
            canDelete,
            canView,
            canViewRestricted
        } = this.props;


        return (
            <div className="documents-panel">
                <div className="cmv-form cmv-form-client-users">
                    <div className="form-subsection">

                        <div className="form-header">
                            <span className="form-header-title">
                                <h6>Documents</h6>
                            </span>
                            {canAdd &&
                                <button type="button" className='btn btn-primary' onClick={() => showModal('ADD_DOCUMENT_MODAL', {type:'create', accountId, canViewRestricted})}>
                                    <i className="fas fa-plus" /> New Document
                                </button>
                            }
                        </div>

                        {documentsLoader
                        ?
                        <Loader/>
                        :
                        !isEmpty(documents)
                        ?
                        documents.map(document => (
                            <Document
                                accountId={accountId}
                                document={document}
                                canView={canView}
                                canEdit={canEdit}
                                canDelete={canDelete}
                                canViewRestricted={canViewRestricted}
                            />
                        ))
                        :
                        <p>No documents found.</p>
                        }

                    </div>
                </div>

            </div>
        )
    }
}

const getLoaderDocuments = createLoadingSelector(['GET_ACCOUNT_DOCUMENTS']);

const mapStateToProps = (state) => {
    const
        documentsLoader = getLoaderDocuments(state),
        documents = getAccountDetails(state).accountDocuments.documents,
        canAdd = getUserPermission(state, "OPER", "OPER_CAN_ADD_DOCUMENTS"),
        canEdit = getUserPermission(state, "OPER", "OPER_CAN_EDIT_DOCUMENTS"),
        canView = getUserPermission(state, "OPER", "OPER_CAN_VIEW_DOCUMENTS"),
        canDelete = getUserPermission(state, "OPER", "OPER_CAN_DEL_DOCUMENTS"),
        canViewRestricted = getUserPermission(state, "OPER", "OPER_CAN_VIEW_RESTRICTED_DOCUMENTS");





    return {
        documentsLoader,
        documents,
        canAdd,
        canEdit,
        canView,
        canDelete,
        canViewRestricted
    };
};

const mapDispatchToProps = {
    getAccountDocuments,
    emptyAccountDocuments,
    createAccountDocument,
    showModal
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);
